/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { CallToActionComponentDisplay } from "cms/components/components/call-to-action/display";
import { CallToActionComponentEditor } from "cms/components/components/call-to-action/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const CallToActionComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <CallToActionComponentDisplay />,
        editComponent: <CallToActionComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

CallToActionComponent.displayName = "CallToActionComponent";
export { CallToActionComponent };
